import { useFilterParams } from "@/hooks/useFilterParams"
import { usePagination } from "@/hooks/usePagination"
import { FC, useEffect, useRef, useState } from "react"
import { useGetResourcesLazyQuery } from "../../../../../graphql"
import { formatDate } from "../../../../../utils"
import Filter from "./components/Filter"
import List from "./components/List"
import "./index.less"

const ListBlock: FC = () => {
  const [getLinksList] = useGetResourcesLazyQuery()

  const downloadBtnRef = useRef<HTMLButtonElement & { link: HTMLAnchorElement | null }>(null)

  const [list, setList] = useState<any>()
  const [totalItems, setTotalItems] = useState<number>(0)
  const [listForExport, setListForExport] = useState<any>()
  const [exportLoading, setExportLoading] = useState<boolean>(false)

  const { page, pageSize, setPage, setPageSize } = usePagination()
  const { filters, setFilters, filtersKey } = useFilterParams({
    selectedCategory: "All",
  })

  const createQueryFilters = () => ({
    ...(filters.selectedCategory !== "All" ? { category: { eq: filters.selectedCategory } } : {}),
  })

  const createList = async (isForExport = false) => {
    if (list && !isForExport) {
      setList(undefined)
    }

    const pagination = {
      pageSize: isForExport ? 1000 : pageSize,
      page: isForExport ? undefined : page,
    }
    const newList = await getLinksList({
      fetchPolicy: "network-only",
      variables: {
        filter: createQueryFilters(),
        sort: "createdAt:desc",
        pagination,
      },
    })

    const totalItems = newList?.data?.appResources?.meta?.pagination?.total || 0
    const finalData = newList?.data?.appResources?.data

    if (finalData && !isForExport) {
      setTotalItems(totalItems)
      setList(finalData)
      return
    } else {
      return finalData
    }
  }

  const createExportList = async () => {
    setExportLoading(true)
    const list = await createList(true)

    let listForExport =
      list?.map((item: any) => [
        item?.id,
        item?.attributes?.category,
        item?.attributes?.description,
        formatDate(item?.attributes?.createdAt),
        (item?.attributes?.file?.data?.attributes?.size / 1000).toFixed(1) + " mb",
      ]) || []

    listForExport = listForExport?.map((item: any) => item.filter((entity: any) => entity !== null))
    listForExport.unshift(["ID", "CATEGORY", "DESCRIPTION", "DATE", "SIZE"])

    setExportLoading(false)
    setListForExport(listForExport)
  }

  useEffect(() => {
    setListForExport(undefined)
    createList()
  }, [pageSize, page, filtersKey])

  useEffect(() => {
    listForExport && downloadBtnRef.current!.link!.click()
  }, [listForExport])

  return (
    <div className={"block-wrapper"}>
      <Filter
        {...{
          filters,
          setFilters,
        }}
      />
      <List
        {...{
          list,
          page,
          setPage,
          filters,
          pageSize,
          totalItems,
          setPageSize,
          listForExport,
          exportLoading,
          downloadBtnRef,
          createExportList,
        }}
      />
    </div>
  )
}

export default ListBlock
